import React from "react";
import { useTranslation } from "../../contexts/TranslationContext";

import '../../assets/css/UC/ViewStyle.scss';

const ViewStyle = ({ viewMode, setViewMode }) => {
    const { language } = useTranslation();
    
    return (
        <div className="view-toggle">
            <button
                className={`toggle-btn ${viewMode === 'grid' ? 'active' : ''}`}
                onClick={() => setViewMode('grid')}
                title={language.gallery?.gridView || "Grid View"}
            >
                <i className="fa fa-th"></i>
            </button>
            <button
                className={`toggle-btn ${viewMode === 'list' ? 'active' : ''}`}
                onClick={() => setViewMode('list')}
                title={language.gallery?.listView || "List View"}
            >
                <i className="fa fa-list"></i>
            </button>
        </div>
    );
}

export default ViewStyle;